module.exports = Object.freeze({
    NONE: 0,
    DELETED: 1,
    SUSPENDED: 2,
    UNREGISTERED: 3,
    PENDING: 4,
    REGISTERED: 5,
    CONFIRMED: 7,
});
